export default __webpack_public_path__ + "static/media/Red0003.e9b55bfe.png";